// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

export abstract class KuromiEngine {

	static STARTING = 'starting';
	static FIRST_BOOT_MENU = 'first-boot-menu';
	static DEVICE_REGISTRATION = 'device-registration';
	static DEVICE_REVOKED = 'device-revoked';
	static PLAYLIST_RUNNING = 'playlist-running';
	static RUNTIME_MENU = 'runtime-menu';
	static ENGINE_ERROR = 'error';

	state: string = KuromiEngine.STARTING;

	abstract start(options: {
		issuer_url: string,
	}): void;
}
